module.exports = "pegasus_template/assets/theme2/small/1.jpg";